import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Card from '../../components/Card';
import BaseButton from '../../components/BaseButton';

import sentIcon from '../../assets/ic_sentiment_satisfied_24px.svg';
import { steps } from '../step/stepSlice';

export default function SuccessScreen() {
  const { step } = useSelector((state) => state.step);
  const dispatch = useDispatch();

  const handleTransferAgain = () => {
    dispatch({ type: 'RESET' });
  };

  if (step !== steps.success) {
    return null;
  }

  return (
    <Fragment>
      <div className="big-title">Completed!</div>
      <Card step={steps.success}>
        <div className="receipt-sent">
          <div className="icon">
            <img src={sentIcon} alt="sent" />
          </div>
          <div className="info-text">Your receipt is on its way</div>
          <BaseButton onClick={handleTransferAgain}>Gift again</BaseButton>

          <div className="or">- OR -</div>
          <div>
            <a className="home-link" href={window.location.origin}>
              Go back to the Home Page
            </a>
          </div>
        </div>
      </Card>
    </Fragment>
  );
}
